<template>
  <div class="monthly-chart">
    <CCard>
      <CCardBody>
        <h5 class="text-primary">Top 5 Application Trend</h5>
        <div>
          <BasicLine :data="getMonthlyChartData" :height="300" />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicLine from "@/components/reusable/Charts/BasicLine.vue";
import { formatDateFormat, getRandomColor } from "../../helpers/helper";
export default {
  name: "MonthlyChart",
  components: {
    BasicLine,
  },
  computed: {
    rankedChartData() {
      const colors = ["#1B4965", "#5FA8D3", "#A2D5AB", "#FFC857"];
      const count = candidate.reduce((acc, item) => {
        if (!acc[item.Program]) {
          acc[item.Program] = 0;
        }
        acc[item.Program]++;
        return acc;
      }, {});
      const data = Object.entries(count).map(([name, value]) => ({
        name,
        value,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
      }));
      const filteredData = data.sort((a, b) => b.value - a.value).slice(0, 5);
      return filteredData;
    },
    getMonthWiseCount() {
      const counts = candidate.reduce((acc, item) => {
        const date = item.application_date;
        const program = item.Program;
        if (!acc[program]) {
          acc[program] = {};
        }
        if (!acc[program][date]) {
          acc[program][date] = 0;
        }
        acc[program][date]++;
        return acc;
      }, {});
      return Object.entries(counts).map(([program, dates]) => ({
        name: program,
        backgroundColor: getRandomColor(),
        value: Object.entries(dates).map(([date, count]) => ({
          name: formatDateFormat(date, "MMM YY"),
          value: count,
        })),
      }));
    },
    getMonthlyChartData() {
      const data = this.getMonthWiseCount;
      const rankedData = this.rankedChartData;
      const filteredData = data
        .filter((item) =>
           rankedData.some((d)=> d.name === item.name)
        );
      const res = filteredData
        .map((item) => {
          return {
            name: item.name,
            values: item.value,
            type: "line",
            tension: 0.3,
            fill: false,
            backgroundColor: item.backgroundColor,
          };
        });
      return res;
    },
  },
};
</script>
